module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/sondrio.8817eb05876b9b920bc4bacd9bff00a2.jpg";